module.exports = __webpack_public_path__ + "images/home/index/templates-develop-797eed38d6ad45c9bd51ab0d359bd39e.png";